<template>
  <div v-loading="showFlag">
    <t-card :style="{ height: '100%', paddingTop: '10px' }">
      <!-- 注文書出力詳細 -->
      <div>
        <t-form
          ref="orderOutputForm"
          :model="orderOutputForm"
          label-position="right"
          label-width="150px"
        >
          <!-- :model="orderOutputForm" -->

          <t-row>
            <!-- 注文番号 -->
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
            >
              <t-form-item
                :label="$t('resource.ORDER.ORDER_NUM')"
                class="marginBottom"
                prop="obOrderNo"
              >
                <t-input
                  v-model="obOrderNoShow"
                  class="commonDialog"
                  maxLength="25"
                  disabled
                >
                </t-input>
              </t-form-item>
            </t-col>
            <!-- 注文日 -->
            <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
            >
              <t-form-item
                :label="$t('resource.ORDER.ORDER_DATE')"
                class="marginBottom"
                prop="obDate"
              >
                <t-date-picker
                  v-model="orderOutputForm.obDate"
                  type="date"
                  value-format="yyyy/MM/dd"
                  style="width: 100%"
                  format="yyyy/MM/dd"
                  disabled
                  :clearable="false"
                  :editable="false"
                ></t-date-picker>
              </t-form-item>
            </t-col>
          </t-row>

          <t-form
            ref="orderOutputForm"
            :model="orderOutputForm"
            label-position="right"
            label-width="150px"
          >
            <div v-show="chnOrJpnFlg">
              <t-row>
                <!-- 会社名 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.OrderExcelOutPut.COMPANY_NAME')"
                    class="marginBottom"
                    prop="obPurchaserCmpName"
                  >
                    <t-input
                      v-model="orderOutputForm.obPurchaserCmpName"
                      class="commonDialog"
                      maxLength="40"
                      disabled
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- 会社名 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.OrderExcelOutPut.SUP_COMPANY_NAME')"
                    class="marginBottom"
                    prop="obSupCmpName"
                  >
                    <t-input
                      v-model="orderOutputForm.obSupCmpName"
                      class="commonDialog"
                      maxLength="50"
                      disabled
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
              </t-row>

              <t-row>
                <!-- 担当者 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.OrderExcelOutPut.CONNECTER')"
                    class="marginBottom"
                    prop="obPurchaserContacts"
                  >
                    <t-input
                      v-model="orderOutputForm.obPurchaserContacts"
                      class="commonDialog"
                      maxLength="20"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- 担当者 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.OrderExcelOutPut.SUP_CONNECTER')"
                    class="marginBottom"
                    prop="obSupContacts"
                  >
                    <t-input
                      v-model="orderOutputForm.obSupContacts"
                      class="commonDialog"
                      maxLength="50"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
              </t-row>

              <t-row>
                <!-- 電話番号 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.OrderExcelOutPut.TEL')"
                    class="marginBottom"
                    prop="obPurchaserTel"
                  >
                    <t-input
                      v-model="orderOutputForm.obPurchaserTel"
                      class="commonDialog"
                      maxLength="15"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- 電話番号 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.OrderExcelOutPut.SUP_TEL')"
                    class="marginBottom"
                    prop="obSupTel"
                  >
                    <t-input
                      v-model="orderOutputForm.obSupTel"
                      class="commonDialog"
                      maxLength="15"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
              </t-row>

              <t-row>
                <!-- メール -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.OrderExcelOutPut.MAIL')"
                    class="marginBottom"
                    prop="obPurchaserMail"
                  >
                    <t-input
                      v-model="orderOutputForm.obPurchaserMail"
                      class="commonDialog"
                      maxLength="50"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- メール -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.OrderExcelOutPut.SUP_MAIL')"
                    class="marginBottom"
                    prop="obSupMail"
                  >
                    <t-input
                      v-model="orderOutputForm.obSupMail"
                      class="commonDialog"
                      maxLength="50"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
              </t-row>

              <t-row>
                <!-- 仕入先の交货地址 -->
                <t-col :span="22">
                  <t-form-item
                    :label="$t('resource.ORDER.SUPPLIER_DELIVERY_ADDR')"
                    class="marginBottom"
                    prop="obSupDeliveryAddress"
                  >
                    <t-input
                      v-model="orderOutputForm.obSupDeliveryAddress"
                      class="commonDialog"
                      maxLength="100"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- 納期 -->
                <!-- <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.ORDER.DELIVERY')"
                    class="marginBottom"
                    prop="obDueDate"
                  >
                    <t-date-picker
                      v-model="orderOutputForm.obDueDate"
                      type="date"
                      :placeholder="$t('resource.sys.hidden')"
                      value-format="yyyy/MM/dd"
                      style="width: 100%"
                      format="yyyy/MM/dd"
                      :clearable="false"
                      :editable="false"
                      disabled
                    ></t-date-picker>
                  </t-form-item>
                </t-col> -->

                <!-- <t-col
              :span="parseInt($t('widgetSize.orderEditDialog.spaceSpanOne'))"
              >&nbsp;</t-col
            > -->
              </t-row>
              <t-row>
                <!-- 郵送方式 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.ORDER.SHIP_METHOD')"
                    class="marginBottom"
                    prop="obShippingMethod"
                  >
                    <t-input
                      v-model="orderOutputForm.obShippingMethod"
                      class="commonDialog"
                      maxLength="30"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- 請求書カテゴリ -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.ORDER.REQUEST_CATEGORY')"
                    class="marginBottom"
                    prop="obInvoiceCategory"
                  >
                    <t-input
                      v-model="orderOutputForm.obInvoiceCategory"
                      class="commonDialog"
                      maxLength="30"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- <t-col
              :span="parseInt($t('widgetSize.orderEditDialog.spaceSpanOne'))"
              >&nbsp;</t-col
            > -->
              </t-row>
              <t-row>
                <!-- 税率 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.documentSet.dsProTaxRate')"
                    class="marginBottom"
                    prop="obTaxRate"
                  >
                    <!-- UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓ -->
                    <!-- <t-input
                      v-model="orderOutputForm.obTaxRate"
                      :controls="false"
                      class="commonDialog"
                      clearable
                      @blur="dataProcess()"
                    > -->
                    <t-input
                      v-model="orderOutputForm.obTaxRate"
                      :controls="false"
                      :max="100"
                      :maxlength="5"
                      class="commonDialog"
                      clearable
                      @blur="dataProcess()"
                    >
                      <!-- UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑ -->
                    </t-input>
                  </t-form-item>
                </t-col>
                <!-- 支払い方法 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.ORDER.PAY_METHOD')"
                    class="marginBottom"
                    prop="obPaymentMethod"
                  >
                    <t-input
                      v-model="orderOutputForm.obPaymentMethod"
                      class="commonDialog"
                      maxLength="30"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- <t-col
              :span="parseInt($t('widgetSize.orderEditDialog.spaceSpanOne'))"
              >&nbsp;</t-col
            > -->
              </t-row>
              <t-row>
                <!-- 支払約定 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.ORDER.PAY_AGREEMENT')"
                    class="marginBottom"
                    prop="obPaymentAgreement"
                  >
                    <t-input
                      v-model="orderOutputForm.obPaymentAgreement"
                      class="commonDialog"
                      maxLength="30"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <!-- 所属項目 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.ORDER.BELONG_PROJECT')"
                    class="marginBottom"
                    prop="obBelongingProject"
                  >
                    <t-input
                      v-model="orderOutputForm.obBelongingProject"
                      class="commonDialog"
                      maxLength="30"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- <t-col
              :span="parseInt($t('widgetSize.orderEditDialog.spaceSpanOne'))"
              >&nbsp;</t-col
            > -->
              </t-row>
              <t-row>
                <!-- その他の規則 -->
                <t-col
                  :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
                >
                  <t-form-item
                    :label="$t('resource.ORDER.OTHER_RULE')"
                    class="marginBottom"
                    prop="obOtherRule"
                  >
                    <t-input
                      v-model="orderOutputForm.obOtherRule"
                      class="commonDialog"
                      maxLength="30"
                      clearable
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <!-- <t-col
              :span="parseInt($t('widgetSize.orderEditDialog.spaceSpanOne'))"
              >&nbsp;</t-col
            > -->
              </t-row>
            </div>
          </t-form>

          <t-form
            ref="orderOutputForm"
            :model="orderOutputForm"
            label-position="right"
            label-width="150px"
          ></t-form>
          <div v-show="!chnOrJpnFlg">
            <t-row>
              <!-- 会社名 -->
              <t-col
                :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
              >
                <t-form-item
                  :label="$t('resource.OrderExcelOutPut.JP_COMPANY_NAME')"
                  class="marginBottom"
                  prop="obSupCmpName"
                >
                  <t-input
                    v-model="orderOutputForm.obSupCmpName"
                    class="commonDialog"
                    maxLength="50"
                    clearable
                  >
                  </t-input>
                </t-form-item>
              </t-col>

              <!-- 担当者 -->
              <t-col
                :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
              >
                <t-form-item
                  :label="$t('resource.OrderExcelOutPut.JP_CONNECTER')"
                  class="marginBottom"
                  prop="obSupContacts"
                >
                  <t-input
                    v-model="orderOutputForm.obSupContacts"
                    class="commonDialog"
                    maxLength="50"
                    style="width: 96%"
                    clearable
                  >
                  </t-input>
                </t-form-item>
              </t-col>
            </t-row>

            <t-row>
              <!-- 件名 -->
              <t-col
                :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
              >
                <t-form-item
                  :label="$t('resource.estimateInfoReferenceInfo.subject')"
                  class="marginBottom"
                  prop="obBelongingProject"
                >
                  <t-input
                    v-model="orderOutputForm.obBelongingProject"
                    class="commonDialog"
                    maxLength="30"
                    clearable
                  >
                  </t-input>
                </t-form-item>
              </t-col>

              <!-- お支払条件 -->
              <t-col
                :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
              >
                <t-form-item
                  :label="$t('resource.estimateInfoReferenceInfo.paymentTerms')"
                  class="marginBottom"
                  prop="obPaymentAgreement"
                >
                  <t-input
                    v-model="orderOutputForm.obPaymentAgreement"
                    class="commonDialog"
                    maxLength="30"
                    clearable
                  >
                  </t-input>
                </t-form-item>
              </t-col>
            </t-row>

            <t-row>
              <!-- 納入方法 -->
              <t-col
                :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
              >
                <t-form-item
                  :label="
                    $t('resource.OrderExcelOutPut.customerReceivingMethod')
                  "
                  class="marginBottom"
                >
                  <t-input
                    v-model="orderOutputForm.obShippingMethod"
                    class="commonDialog"
                    maxLength="30"
                    clearable
                  >
                  </t-input>
                </t-form-item>
              </t-col>

              <!-- 貴社見積№ -->
              <t-col
                :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ELEVEN'))"
              >
                <t-form-item
                  :label="$t('resource.OrderExcelOutPut.supCode')"
                  class="marginBottom"
                >
                  <t-input
                    v-model="orderOutputForm.obCmpQuoteNo"
                    class="commonDialog"
                    maxLength="25"
                    clearable
                  >
                  </t-input>
                </t-form-item>
              </t-col>
            </t-row>
          </div>

          <div>
            <t-row>
              <!-- 備考 -->
              <t-col
                :span="
                  parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_TWO'))
                "
              >
                <t-form-item
                  :label="$t('resource.COMMON_CONSTANT.BIKOU')"
                  class="marginBottom"
                  label-width="150px"
                >
                  <t-input
                    v-model="orderOutputForm.obRemarks"
                    type="textarea"
                    class="commonDialog dialog_bikou"
                    maxlength="500"
                    placeholder="備考"
                    show-word-limit
                  >
                  </t-input>
                </t-form-item>
              </t-col>

              <!-- <t-col
              :span="parseInt($t('widgetSize.orderEditDialog.spaceSpanOne'))"
              >&nbsp;</t-col
            > -->
            </t-row>
          </div>
        </t-form>
      </div>

      <div>
        <t-form label-position="right" label-width="150px">
          <t-row type="flex" justify="end">
            <div>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
              <t-col
                :span="
                  parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_TWO'))
                "
              >
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  @click="Confirm"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
//import { DeleteOrderInfo, SearchOrderInfo } from "@/services/orderInfo";
import { httpApi } from "@/api/api";
import { t } from "@/locales";
import { outputExcelToZip, updateStatusAfterOutput } from "@/services/common";
import { getOrderOutPutInfo } from "@/services/order";
import { numberFormat } from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT, FACTORY_KBN_DALIAN } from "@/utils/const";
import { Message } from "@tellus/component";
//import { DateFormat } from "@/utils/filter";

// import { ShowTestDialogA } from "@/components/Dialog";
// import { GetPageDataCount } from "@/utils/const";
// import { Modal } from "@tellus/component";
//import moment from "moment";
export default {
  data() {
    return {
      //true:見積依頼書出力ボタンをクリックできない  false:見積依頼書出力ボタンをクリックできる
      buttonClickFlag: true,
      //仕入先見積依頼のテーブル
      orderOutputForm: {
        obOrderNo: "", // 注文番号
        obDate: "", // 注文日
        // 購入先
        obPurchaserCmpName: "", // 会社名
        obPurchaserContacts: "", // 担当者
        obPurchaserTel: "", // 電話番号
        obPurchaserMail: "", // メール
        //仕入先
        obSupCmpName: "", // 会社名
        obSupContacts: "", // 担当者
        obSupTel: "", // 電話番号
        obSupMail: "", // メール
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        //obDueDate: "", // 納期
        obDueDateMin: "", // 納期最小値
        obDueDateMax: "", // 納期最大値
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        obShippingMethod: "", // 郵送方式
        obSupDeliveryAddress: "", // 仕入先の交货地址
        obInvoiceCategory: "", // 請求書カテゴリ
        obTaxRate: "", // 税率
        obPaymentMethod: "", // 支払い方法
        obPaymentAgreement: "", // 支払約定
        obBelongingProject: "", // 所属項目
        obOtherRule: "", // その他の規則
        obRemarks: "", // 備考
      },
      maxheight: 160,

      //追加された「仕入先」列の番号
      newColumnNo: 0,

      //待ちダイアログ　true:表示　false:表示しない
      showFlag: false,

      isSupplierReference: false,
      supplierReferenceArr: [],
      supplierReferenceList: [],

      chnOrJpnFlg: "",

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT,
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },

    obOrderNo: {
      Type: Object,
    },

    obOrderNoShow: {
      Type: Object,
    },

    SupCurrency: {
      Type: Object,
    },

    FactoryKbn: {
      Type: Object,
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
    obDate: {
      Type: Object,
    },
    // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
  },

  created() {
    this.showFlag = true;
    this.editDialogHigh();
    this.init(this.obOrderNo);
  },

  methods: {
    // 初期化
    init(data) {
      getOrderOutPutInfo(data)
        .then((res) => {
          this.orderOutputForm = res;
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
          this.orderOutputForm.obDate = this.obDate;
          // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })

        .finally(() => (this.showFlag = false));
    },

    editDialogHigh() {
      if (this.FactoryKbn === FACTORY_KBN_DALIAN) {
        this.chnOrJpnFlg = true;
      } else {
        this.chnOrJpnFlg = false;
      }

      if (this.chnOrJpnFlg) {
        const dialog = document.querySelector(
          ".el-dialog.orderExcelOutputHeight"
        );

        dialog.style.height = "630px";
      }
    },

    //「確定」ボタン
    Confirm() {
      this.showFlag = true;

      // フォーカス削除
      if (typeof this.$refs.confirmBtn !== "undefined") {
        this.$refs.confirmBtn.$el.blur();
      }

      // console.log(this.isAdd);

      if (this.isAdd) {
        this.showFlag = false;
        this.$emit("ok", this.orderOutputForm);
      } else {
        outputExcelToZip(httpApi.OutPutOrderInfo, this.orderOutputForm).finally(
          () => {
            // this.getRequestDetailInfoByNo(this.reqInfoEditForm);
            this.showFlag = false;

            // UPD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 start↓
            // this.$emit("cancel");

            // 出力が成功の場合、手配状態が「手配済み」を変更
            updateStatusAfterOutput({
              statusName: "obStatus",
              dataNo: this.orderOutputForm.obOrderNo,
            }).finally(() => {
              this.$emit("cancel");
            });
            // UPD 2025/03/19 ZLL 課題_出力後、状態の自動変更の追加 end↑
          }
        );
      }
    },

    //データの処理
    dataProcess() {
      //提成率(%)
      this.orderOutputForm.obTaxRate = numberFormat(
        this.orderOutputForm.obTaxRate,
        "0.00"
      );

      if (this.orderOutputForm.obTaxRate > 99.99) {
        this.orderOutputForm.obTaxRate = 99.99;
      } else if (this.orderOutputForm.obTaxRate < 0) {
        this.orderOutputForm.obTaxRate = 0;
      } else {
        this.orderOutputForm.obTaxRate = this.orderOutputForm.obTaxRate;
      }
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },
  },
};
</script>
<style scoped>
</style>
